/*
 * Awhi — collection grid + featured collection behaviours (Phase 4).
 *
 * 1. Filter/sort form auto-submits on change (plain GET — Search &
 *    Discovery facet params are read server-side by Liquid).
 * 2. Filter dropdowns (<details>) close on outside click / Escape.
 * 3. Card quick-add posts to /cart/add.js then opens the Awhi cart
 *    drawer via the same "wetheme-toggle-right-drawer" event the
 *    Phase 3 drawer intercepts, and announces "wetheme-cart-update"
 *    so the header count pill stays in sync.
 *
 * Loaded per-section; the guard below keeps delegated listeners
 * single-bound if two sections include the script on one page.
 */
(function () {
  'use strict';

  if (window.AwhiCollectionJsBound) return;
  window.AwhiCollectionJsBound = true;

  var TOGGLE_EVENT = 'wetheme-toggle-right-drawer';
  var UPDATE_EVENT = 'wetheme-cart-update';

  /* ------------------------------------------------ filters */

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-awhi-clx-filters]');
    if (!form) return;
    var section = form.closest('.awhi-clx');
    if (section) section.classList.add('is-loading');
    form.submit();
  });

  function closeDropdowns(except) {
    var open = document.querySelectorAll('details.awhi-clx__dd[open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].removeAttribute('open');
    }
  }

  document.addEventListener('click', function (e) {
    var inside = e.target.closest('details.awhi-clx__dd');
    closeDropdowns(inside);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDropdowns(null);
  });

  /* ------------------------------------------------ carousels

     Shared arrow control for any [data-awhi-carousel]: scrolls its
     track by one visible page. Delegated so sections added later
     work without re-binding. */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-awhi-carousel-prev], [data-awhi-carousel-next]');
    if (!btn) return;
    var scope = btn.closest('[data-awhi-carousel]');
    if (!scope) return;
    var track = scope.querySelector('[data-awhi-carousel-track]');
    if (!track) return;

    var first = track.firstElementChild;
    var step = first ? first.getBoundingClientRect().width + 20 : track.clientWidth;
    var dir = btn.hasAttribute('data-awhi-carousel-prev') ? -1 : 1;
    track.scrollBy({ left: step * dir, behavior: 'smooth' });
  });

  /* Disable the prev/next arrow at the ends of the track so the
     inactive one paints in the #E0D8CD :disabled colour (Daniel 25/07). */
  function updateCarouselArrows(scope) {
    var track = scope.querySelector('[data-awhi-carousel-track]');
    if (!track) return;
    var prev = scope.querySelector('[data-awhi-carousel-prev]');
    var next = scope.querySelector('[data-awhi-carousel-next]');
    var max = track.scrollWidth - track.clientWidth;
    var x = track.scrollLeft;
    if (prev) prev.disabled = x <= 1;
    if (next) next.disabled = x >= max - 1;
  }

  function initCarouselArrows() {
    var scopes = document.querySelectorAll('[data-awhi-carousel]');
    for (var i = 0; i < scopes.length; i++) {
      (function (scope) {
        var track = scope.querySelector('[data-awhi-carousel-track]');
        if (!track) return;
        updateCarouselArrows(scope);
        track.addEventListener('scroll', function () { updateCarouselArrows(scope); }, { passive: true });
      })(scopes[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', initCarouselArrows);
  window.addEventListener('load', initCarouselArrows);
  window.addEventListener('resize', function () {
    var scopes = document.querySelectorAll('[data-awhi-carousel]');
    for (var i = 0; i < scopes.length; i++) updateCarouselArrows(scopes[i]);
  });

  /* ------------------------------------------------ UGC clips

     The UGC wall autoplays muted and chromeless (Daniel 04/08). The markup
     carries no `autoplay` attribute on purpose: with `preload="none"` a clip
     is not fetched until it scrolls into view, so the five-clip section costs
     one video on a phone instead of five 1080p files. Clips pause off-screen
     and while the tab is hidden.

     Reduced motion gets the first frame and no playback. There are no
     controls, so a clip that simply never starts would read as a dead tile —
     the frame is what keeps the card looking like a card. Same reason the
     blocked-autoplay and no-IntersectionObserver paths both land somewhere
     visible rather than on an empty box. */

  var UGC_SELECTOR = '[data-awhi-ugc-video]';

  /* preload="none" means there is nothing to paint yet; asking for metadata
     pulls just enough to show frame one. */
  function ugcFirstFrame(video) {
    video.preload = 'metadata';
    video.load();
  }

  function ugcPlay(video) {
    // Safari trusts the property over the attribute when play() is scripted.
    video.muted = true;
    var played = video.play();
    if (played && played.catch) {
      played.catch(function () {
        ugcFirstFrame(video);
      });
    }
  }

  function initUgcVideos() {
    var videos = document.querySelectorAll(UGC_SELECTOR);
    var i;
    if (!videos.length) return;

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (i = 0; i < videos.length; i++) ugcFirstFrame(videos[i]);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      for (i = 0; i < videos.length; i++) ugcPlay(videos[i]);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j++) {
          var video = entries[j].target;
          if (entries[j].isIntersecting) {
            video.setAttribute('data-awhi-inview', '');
            ugcPlay(video);
          } else {
            video.removeAttribute('data-awhi-inview');
            video.pause();
          }
        }
      },
      /* A quarter visible is enough to count as on-screen. The track is an
         overflow-x scroller, so cards paged out sideways are clipped by it and
         report as not intersecting — the rail gates itself. */
      { threshold: 0.25 }
    );

    for (i = 0; i < videos.length; i++) {
      if (videos[i].hasAttribute('data-awhi-ugc-bound')) continue;
      videos[i].setAttribute('data-awhi-ugc-bound', '');
      observer.observe(videos[i]);
    }
  }

  /* Backgrounded tabs keep decoding video otherwise. Nothing intersects
     differently on the way back, so the observer will not restart them —
     hence resuming from the flag it left behind. */
  document.addEventListener('visibilitychange', function () {
    var videos = document.querySelectorAll(UGC_SELECTOR);
    for (var i = 0; i < videos.length; i++) {
      if (document.hidden) videos[i].pause();
      else if (videos[i].hasAttribute('data-awhi-inview')) ugcPlay(videos[i]);
    }
  });

  document.addEventListener('DOMContentLoaded', initUgcVideos);
  window.addEventListener('load', initUgcVideos);
  // Re-placing the section in the customizer rebuilds the <video> elements.
  document.addEventListener('shopify:section:load', initUgcVideos);

  /* ------------------------------------------------ quick add */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-awhi-quick-add]');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || (button && button.disabled)) return;

    var originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    function restore() {
      if (!button) return;
      button.disabled = false;
      button.textContent = originalLabel;
    }

    window
      .fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(idInput.value), quantity: 1 }]
        })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        return window
          .fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          });
      })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent(UPDATE_EVENT, { detail: { cart: cart } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent(TOGGLE_EVENT, {
            detail: { type: 'cart', forceOpen: true }
          })
        );
        restore();
      })
      .catch(function () {
        restore();
        // Fallback: let the native form action add via full page load.
        form.removeAttribute('data-awhi-quick-add');
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
  });
})();
